"use strict";

var urlHelper = require("../helpers/urlHelpers");

/**
* Updates the browser's URL to reflect the current pagination state by modifying the "sz" and "start" query parameters.
* Utilizes the History API to push the updated URL without reloading the page.
*
* @param {string} pageUrl - The URL containing the pagination query parameters ("sz" for page size and "start" for start index).
*/
function updateWindowUrl(pageUrl) {
    var sz = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "sz") : null;
    var start = pageUrl ? urlHelper.getQueryStringValue(pageUrl, "start") : null;

    if (sz && start) {
        var windowUrl = window.location.href;

        windowUrl = urlHelper.insertParam(windowUrl, "start", start);
        windowUrl = urlHelper.insertParam(windowUrl, "sz", sz);

        window.history.pushState(null, null, windowUrl);
    }
}

/**
* Attaches a click event handler to the "Show More" pagination button within the product search container.
* When triggered, it performs an AJAX request to load additional product results, updates the product grid,
* manages browser history state for pagination, updates sorting and pagination controls, and scrolls to the top of the page.
* Also handles spinner display during the asynchronous operation and updates the displayed count of loaded products.
*
* @fires search:showMore - Triggered before the AJAX request to allow for additional event handling.
* @listens click - Listens for clicks on elements with the '.btn-page' class inside '.container'.
* @returns {void}
*/
function showMore() {
    $(".container").on("click", ".btn-page", function (e) {
        e.stopPropagation();
        e.preventDefault();
        $.spinner().start();

        var pageLinkUrl = $(this).data("url");

        if (pageLinkUrl) {
            $.ajax({
                url: pageLinkUrl,
                data: { selectedUrl: pageLinkUrl },
                method: "GET",
                success: function (response) {
                    $(".product-grid").html(response);
                    updateWindowUrl(pageLinkUrl);
                    $("html, body").animate({scrollTop: 0}, 400);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });
}

/**
* Expands refinement sections that contain selected options by adding the 'active' class.
* Iterates over all elements with the 'refinement' class and checks if any child element has the 'selected' class.
* If a selected option is found, the parent refinement section is marked as active.
*
* @returns {void}
*/
function keepRefinementsExpanded() {
    $(".refinement").each(function () {
        var $toggle = $(this);
        var hasSelected = $toggle.find(".selected").length > 0;

        if (hasSelected) {
            $toggle.addClass("active");
        }
    });
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        var $this = $(this);
        $this.removeClass("active");
        var activeDiv = $results.find("." + $this[0].className.replace(/ /g, "."));
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });

    updateDom($results, ".refinements");
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header",
        ".header-bar",
        ".page-title-container",
        ".product-grid",
        ".show-more",
        ".filter-bar",
        ".vehicle-selector-container",
        ".breadcrumbs-container",
        ".vehicle-selector-filter"
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
* Handles the application of a search filter when a filter element is interacted with.
* Prevents default event behavior, triggers a custom filter event, updates the browser history with the SEO-friendly URL,
* and performs an AJAX request to retrieve and display filtered search results. Manages UI spinner and focus for accessibility.
*
* @param {Event} e - The event object triggered by the filter action.
* @param {jQuery} jqueryElement - The jQuery-wrapped DOM element representing the filter control (e.g., select or button).
*/
function handleApplyFilter(e, jqueryElement) {
    if (!e || !jqueryElement) {
        return;
    }

    e.preventDefault();
    e.stopPropagation();

    $.spinner().start();
    var $this = jqueryElement;
    $this.trigger("search:filter", e);

    var searchUrl = $this.is("select")
        ? $this.find("option:selected").data("href")
        : $this.data("href");
    var seoUrl = $this.is("select")
        ? $this.find("option:selected").data("seo-href") || searchUrl
        : $this.data("seo-href") || searchUrl;

    if (seoUrl) {
        window.history.pushState({}, null, seoUrl);
    }

    var attributeId = "#" + $this.find("span").last().attr("id");
    $.ajax({
        url: searchUrl,
        data: {
            page: $(".grid-footer").data("page-number"),
            selectedUrl: searchUrl
        },
        method: "GET",
        success: function (response) {
            parseResults(response);
            $.spinner().stop();
            $(attributeId).parent("button").focus();
        },
        error: function () {
            $.spinner().stop();
            $(attributeId).parent("button").focus();
        }
    });
}

/**
 * Sets up event handlers for filter interactions in a container.
 *
 * Handles click and change events on refinement and filter elements,
 * and updates the default option's href in select elements.
 *
 * Relies on `handleApplyFilter` for processing.
 */
function applyFilter() {
    var $container = $(".container");

    // Handle refinement value selection and reset click
    $container.on(
        "click",
        ".refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button",
        function (e) {
            handleApplyFilter(e, $(this));
        }
    );

    // handles refinement value selection but for select elements
    $container.on(
        "change",
        ".vehicle-selector-search select",
        function (e) {
            handleApplyFilter(e, $(this));
        }
    );

    // sets the href value to the default option based on the selected option
    $container.on(
        "focus",
        ".vehicle-selector-search select",
        function () {
            var $this =  $(this);
            var $defaultOption = $this.find("option:first");
            var $selectedOption = $this.find("option:selected");
            var selectedHref = $selectedOption.data("href");

            $defaultOption.attr("data-href", selectedHref);
        }
    );
}

/**
* Slides toggle content up and down
* @param {Object} $toggleSlideBtn - the target slide toggle button
*/
function slideToggleContent($toggleSlideBtn) {
    var $slideToggleContainer = $toggleSlideBtn.closest(".slide-toggle-container");
    var $slideToggleContent = $slideToggleContainer.find(".slide-toggle-content");
    var slideBtnTextMore = $toggleSlideBtn.data("more");
    var slideBtnTextLess = $toggleSlideBtn.data("less");

    if ($toggleSlideBtn.hasClass("js-slide-show-less")) {
        $slideToggleContent.slideUp(400, function () {
            $toggleSlideBtn
                .removeClass("js-slide-show-less")
                .addClass("js-slide-show-more")
                .text(slideBtnTextMore);
        });
    } else {
        $slideToggleContent.slideDown(400, function () {
            $toggleSlideBtn
                .removeClass("js-slide-show-more")
                .addClass("js-slide-show-less")
                .text(slideBtnTextLess);
        });
    }
}

/**
 * Binds click events for show more/less toggles
 * and calls `slideToggleContent()` on the clicked element.
 */
function initToggleContent() {
    $(document).on("click", ".js-slide-show-less, .js-slide-show-more", function () {
        slideToggleContent($(this));
    });
}

export default function search() {
    showMore();
    keepRefinementsExpanded();
    applyFilter();
    initToggleContent();
}
